import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {Keyword} from "../../domain/entities/keyword.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityChangedPayload} from "../../message-broker/payloads/entity-changed.payload";
import {CommandBus} from "../../services/command-bus.service";
import {RecolorKeywordCommand} from "../recolor-keyword.command";
import {RecolorContent} from "../payloads/recolor-content";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(RecolorKeywordCommand)
@singleton()
export class RecolorKeywordCommandHandler implements ICommandHandler<RecolorContent> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker,
    ) {
    }

    public async handle(command: RecolorKeywordCommand): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }

        // The payload is the RecolorContent sent to the backend; the entity travels beside it (feature plan 0074).
        const keyword = command.entity;
        this._messageBroker.publish<EntityChangedPayload<Keyword>>({
            type: `entity.changed`,
            identityHash: keyword.uid,
            payload: {
                uid: keyword.uid,
                prototype: Keyword,
                changeSet: keyword.changeSet
            }
        });
        keyword.markAsPersisted();
    }
}